/*
 * @Author: yyl
 * @Date: 2025-06-25 10:33:57
 * @LastEditTime: 2025-07-01 17:28:20
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/router/index.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/HomeView.vue'
import ArticleView from '@/views/ArticleView.vue'
import ListView from '@/views/ListView.vue'
import ListImageView from '@/views/ListImageView.vue'
import Teachers from '@/views/TeachersView.vue'
import Admission from '@/views/AdmissionView.vue'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/article', name: 'ArticleView', component: ArticleView },
    { path: '/list', name: 'ListView', component: ListView },
    { path: '/list-image', name: 'ListImageView', component: ListImageView },
    { path: '/teachers', name: 'Teachers', component: Teachers },
    { path: '/admission', name: 'Admission', component: Admission },
  ],
})